<aside class="sidebar">
  <div class="company-info">
    <img [src]="activeCompany?.imagePngSrc" alt="Company Logo">
  </div>

  <ul class="sidebar-menu">
    <div>
      <li><a routerLink="/agent">Home</a></li>
      <!-- <li><a routerLink="/about">About</a></li>
      <li><a routerLink="/services">Services</a></li> -->
    </div>
    <div class="contact-section">
      <li><span class="contact-title">Contact</span></li>
      <li><a class="email" href="mailto:{{ activeCompany?.salesEmail }}" target="_blank">{{
          activeCompany?.salesEmail}}</a></li>
      <li><a class="email" href="mailto:{{ activeCompany?.supportEmail }}" target="_blank">{{activeCompany?.supportEmail
          }}</a></li>
    </div>
  </ul>
</aside>